import { Backdrop, Box, CircularProgress, Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Column, CustomTable, IAction } from "../generic/CustomTable";
import { IBlog } from "../../types/CommonTypes";
import useBlog from "../../commons/hooks/useBlog";
import { CheckBox } from "@mui/icons-material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { useNavigate } from "react-router-dom";

interface IProps {
	onEdit: (blog: IBlog) => void;
	onReset?: (location: string) => void;
	newItemRef?: string;
}

export default function BlogList({ onEdit, newItemRef, onReset }: IProps) {
	const [limit, setLimit] = useState<number>(10);
	const [prevPage, setPrevPage] = useState<number>(0);
	const { blogs, loading, deleteBlog, retrieveBlogs } = useBlog({});
	const navigate = useNavigate();

	useEffect(() => {
		retrieveBlogs(limit);
	}, [limit]);

	const onPageChange = (number: number) => {
		if (number > 0 && number > prevPage && blogs.length > prevPage) {
			setPrevPage(prevPage + 1);
			if (number > prevPage) setLimit(limit + 10);
		}
	};

	const blogsWithActions = useCallback(() => {
		return blogs.map((item: any) => ({
			...item,
		}));
	}, [blogs]);

	const columns: Column[] = [
		{ field: "date", headerName: "Fecha creación", type: "dateTime" },
		{ field: "title", headerName: "Título" },
		{ field: "summary", headerName: "Descripción" },
		{ field: "slug", headerName: "Slug" },
		{ field: "action", headerName: "Acciones" },
	];

	const actions: IAction[] = [
		{
			label: "Ver",
			action: (blog) =>
				navigate(`/blog/${blog.slug}`, { state: { blog } }),
		},
		// {
		// 	label: "Editar",
		// 	action: (blog) => onEdit(blog),
		// },
		{
			label: "Eliminar",
			action: (blog) => deleteBlog(blog),
		},
	];

	return (
		<Grid container>
			<CustomTable
				buttonRefClick={onReset}
				buttonRef={"Crear nuevo blog"}
				columns={columns}
				rows={blogsWithActions()}
				headerName="Blogs"
				sortField="date"
				actions={actions}
				loading={false}
				onPageChange={onPageChange}
			/>
			<Backdrop
				open={loading}
				sx={{
					color: "#fff",
					zIndex: (theme) => theme.zIndex.drawer + 1,
				}}
			>
				<CircularProgress color="primary" />
			</Backdrop>
		</Grid>
	);
}
